module.exports = __webpack_public_path__ + "img/iland-logo.edcceb45.png";